/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect } from "react";

const VideoPlayer = (props) => {
  const playerRef = useRef();

  useEffect(() => {
    let player;
    const setup = async () => {
      const {default:videojs} = await import("video.js");
      player = videojs(
        playerRef.current,
        props,
        function onPlayerReady() { }
      );

    }
    setup();
    return () => {
      if (player) {
        player.dispose();
      }
    };
  }, []);

  const { poster, className } = props;

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div data-vjs-player style={{ ...props?.containerStyle }}>
        <video
          ref={playerRef}
          poster={poster}
          className={className || ""}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
